
    /*!
    * Copyright (c) Microsoft Corporation.
    * All rights reserved. See LICENSE in the project root for license information.
    * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
    * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
    */
    import {
        AsyncResult,
        callActionOrExecute,
        DataServiceQuery,
        IContext,
        IDataServiceRequest,
        // @ts-ignore -- Unused import
        NullResult
    } from '@msdyn365-commerce/retail-proxy';
    // @ts-ignore -- Unused import
    import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
    // @ts-ignore -- Unused import
    import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
    import * as DataServiceEntities from './ProgressiveDataServiceEntities.g';


        // @ts-ignore
        function progressiveQuery(id?: number): DataServiceQuery {
        const key = (id) ? { Id: id } :null;
        return new DataServiceQuery("Progressive", "LeaseLookupByCustomer", DataServiceEntities.LeaseLookupByCustomerExtensionClass, key);
        }


    export function createMFIGetLeaseLookupByCustomerInput(leaseLookupByCustomer: DataServiceEntities.ILeaseLookupByCustomerRequest): IDataServiceRequest {
    const query = progressiveQuery();
    return query.createDataServiceRequestForOperation('MFIGetLeaseLookupByCustomer', true, DataServiceEntities.MFILeaseLookupByCustomerResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFILeaseLookupByCustomerResponse'}, {leaseLookupByCustomer: leaseLookupByCustomer });
    }


    export function mFIGetLeaseLookupByCustomerAsync(context: IContext, leaseLookupByCustomer: DataServiceEntities.ILeaseLookupByCustomerRequest): AsyncResult<DataServiceEntities.IMFILeaseLookupByCustomerResponse> {
    const request = createMFIGetLeaseLookupByCustomerInput(leaseLookupByCustomer);
    return callActionOrExecute<DataServiceEntities.IMFILeaseLookupByCustomerResponse>(request, context.callerContext);
    }

    export function createMFIGetPaymentEstimatesInput(paymentEstimate: DataServiceEntities.IPaymentEstimateRequest): IDataServiceRequest {
    const query = progressiveQuery();
    return query.createDataServiceRequestForOperation('MFIGetPaymentEstimates', true, DataServiceEntities.MFIGetPaymentEstimateResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFIGetPaymentEstimateResponse'}, {paymentEstimate: paymentEstimate });
    }


    export function mFIGetPaymentEstimatesAsync(context: IContext, paymentEstimate: DataServiceEntities.IPaymentEstimateRequest): AsyncResult<DataServiceEntities.IMFIGetPaymentEstimateResponse> {
    const request = createMFIGetPaymentEstimatesInput(paymentEstimate);
    return callActionOrExecute<DataServiceEntities.IMFIGetPaymentEstimateResponse>(request, context.callerContext);
    }

    export function createMFISubmitCartInformationInput(submitCartInformation: DataServiceEntities.ISubmitCartInformationRequest): IDataServiceRequest {
    const query = progressiveQuery();
    return query.createDataServiceRequestForOperation('MFISubmitCartInformation', true, DataServiceEntities.MFISubmitCartInformationResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFISubmitCartInformationResponse'}, {submitCartInformation: submitCartInformation });
    }


    export function mFISubmitCartInformationAsync(context: IContext, submitCartInformation: DataServiceEntities.ISubmitCartInformationRequest): AsyncResult<DataServiceEntities.IMFISubmitCartInformationResponse> {
    const request = createMFISubmitCartInformationInput(submitCartInformation);
    return callActionOrExecute<DataServiceEntities.IMFISubmitCartInformationResponse>(request, context.callerContext);
    }

    export function createMFIGetLeaseContractInput(leaseContract: DataServiceEntities.IGetLeaseContractRequest): IDataServiceRequest {
    const query = progressiveQuery();
    return query.createDataServiceRequestForOperation('MFIGetLeaseContract', true, DataServiceEntities.MFIGetLeaseContractResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFIGetLeaseContractResponse'}, {leaseContract: leaseContract });
    }


    export function mFIGetLeaseContractAsync(context: IContext, leaseContract: DataServiceEntities.IGetLeaseContractRequest): AsyncResult<DataServiceEntities.IMFIGetLeaseContractResponse> {
    const request = createMFIGetLeaseContractInput(leaseContract);
    return callActionOrExecute<DataServiceEntities.IMFIGetLeaseContractResponse>(request, context.callerContext);
    }

    export function createMFIOrderConfirmationInput(orderConfirmation: DataServiceEntities.IOrderConfirmationRequest): IDataServiceRequest {
    const query = progressiveQuery();
    return query.createDataServiceRequestForOperation('MFIOrderConfirmation', true, DataServiceEntities.MFIOrderConfirmationResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFIOrderConfirmationResponse'}, {orderConfirmation: orderConfirmation });
    }


    export function mFIOrderConfirmationAsync(context: IContext, orderConfirmation: DataServiceEntities.IOrderConfirmationRequest): AsyncResult<DataServiceEntities.IMFIOrderConfirmationResponse> {
    const request = createMFIOrderConfirmationInput(orderConfirmation);
    return callActionOrExecute<DataServiceEntities.IMFIOrderConfirmationResponse>(request, context.callerContext);
    }

    export function createMFIDeleteTransactionInput(deleteContract: DataServiceEntities.IDeleteTransactionRequest): IDataServiceRequest {
    const query = progressiveQuery();
    return query.createDataServiceRequestForOperation('MFIDeleteTransaction', true, DataServiceEntities.MFIDeleteTransactionResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFIDeleteTransactionResponse'}, {deleteContract: deleteContract });
    }


    export function mFIDeleteTransactionAsync(context: IContext, deleteContract: DataServiceEntities.IDeleteTransactionRequest): AsyncResult<DataServiceEntities.IMFIDeleteTransactionResponse> {
    const request = createMFIDeleteTransactionInput(deleteContract);
    return callActionOrExecute<DataServiceEntities.IMFIDeleteTransactionResponse>(request, context.callerContext);
    }

    export function createMFIGetPricingInformationInput(pricingInformation: DataServiceEntities.IGetPricingInformationRequet): IDataServiceRequest {
    const query = progressiveQuery();
    return query.createDataServiceRequestForOperation('MFIGetPricingInformation', true, DataServiceEntities.MFIGetPricingInformationResponseExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.IMFIGetPricingInformationResponse'}, {pricingInformation: pricingInformation });
    }


    export function mFIGetPricingInformationAsync(context: IContext, pricingInformation: DataServiceEntities.IGetPricingInformationRequet): AsyncResult<DataServiceEntities.IMFIGetPricingInformationResponse> {
    const request = createMFIGetPricingInformationInput(pricingInformation);
    return callActionOrExecute<DataServiceEntities.IMFIGetPricingInformationResponse>(request, context.callerContext);
    }
